import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Box, Button, Typography } from '@drone-js/core';
import { ActivitiesCancellationPolicyInfoModalCloseButtonClickEventFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesCancellationPolicyInfoModalCloseButtonClickEventManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { closeOverlay, OverlayType, selectRiskFreeCancellationOverlayVisible } from 'store/slice/overlay';
import { getCancellationPolicyModalDescription } from 'component/page/detail/CancellationPolicyCard/cancellationUtil';
import { trackElementEvent } from 'core/messaging/analytics/analytics';

export const CancellationPolicyInfoModal: React.FC<{ hoursUntil: number }> = ({ hoursUntil }) => {
    const dispatch = useDispatch();
    const cms = useSelector(selectCmsFromBootstrap);
    const isInfoModalOpen = useSelector(selectRiskFreeCancellationOverlayVisible);
    const closePolicyInfoModal = () => dispatch(closeOverlay(OverlayType.RiskFreeCancellation));
    const description = React.useMemo(() => getCancellationPolicyModalDescription(hoursUntil, cms), [hoursUntil, cms]);

    const handleModalCloseButtonClick = () => {
        trackElementEvent<ActivitiesCancellationPolicyInfoModalCloseButtonClickEventFieldsV1>(ActivitiesCancellationPolicyInfoModalCloseButtonClickEventManifestV1.ids, {});
        closePolicyInfoModal();
    };

    return (
        <Modal
            data-testId="activities-cancellation-policy-info-modal"
            title={cms[149966]}
            size="s"
            visible={isInfoModalOpen}
            onClose={handleModalCloseButtonClick}
            onCloseCompleted={closePolicyInfoModal}
        >
            <Box textAlign="center">
                <Typography data-testid="activities-cancellation-policy-info-modal-content-primary" variant="body-s" my="12">
                    {description.primary}
                </Typography>
                <Typography data-testid="activities-cancellation-policy-info-modal-content-secondary" variant="body-s" my="12">
                    {description.secondary}
                </Typography>
                <Button
                    data-element-name="activities-cancellation-policy-info-modal-close-button"
                    data-testid="activities-cancellation-policy-info-modal-close-button"
                    variant="label"
                    width="parent-fit"
                    onClick={handleModalCloseButtonClick}
                    label={cms[126815]}
                />
            </Box>
        </Modal>
    );
};
CancellationPolicyInfoModal.displayName = 'CancellationPolicyInfoModal';
